import { __extends } from "tslib";
import { VerifyRequest, VerifyResponse } from "../models/models_0";
import { deserializeAws_json1_1VerifyCommand, serializeAws_json1_1VerifyCommand } from "../protocols/Aws_json1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
/**
 * <p>Verifies a digital signature that was generated by the <a>Sign</a> operation. </p>
 *          <p></p>
 *          <p>Verification confirms that an authorized user signed the message with the specified CMK
 *       and signing algorithm, and the message hasn't changed since it was signed. If the signature is
 *       verified, the value of the <code>SignatureValid</code> field in the response is
 *         <code>True</code>. If the signature verification fails, the <code>Verify</code> operation
 *       fails with an <code>KMSInvalidSignatureException</code> exception.</p>
 *          <p>A digital signature is generated by using the private key in an asymmetric CMK. The
 *       signature is verified by using the public key in the same asymmetric CMK.
 *       For information about symmetric and asymmetric CMKs, see <a href="https://docs.aws.amazon.com/kms/latest/developerguide/symmetric-asymmetric.html">Using Symmetric and Asymmetric CMKs</a> in the <i>AWS Key Management Service Developer Guide</i>.</p>
 *          <p>To verify a digital signature, you can use the <code>Verify</code> operation. Specify the
 *       same asymmetric CMK, message, and signing algorithm that were used to produce the
 *       signature.</p>
 *          <p>You can also verify the digital signature by using the public key of the CMK outside of
 *       AWS KMS. Use the <a>GetPublicKey</a> operation to download the public key in the
 *       asymmetric CMK and then use the public key to verify the signature outside of AWS KMS. The
 *       advantage of using the <code>Verify</code> operation is that it is performed within AWS KMS. As
 *       a result, it's easy to call, the operation is performed within the FIPS boundary, it is logged
 *       in AWS CloudTrail, and you can use key policy and IAM policy to determine who is authorized to use
 *       the CMK to verify signatures.</p>
 *          <p>The CMK that you use for this operation must be in a compatible key state. For
 * details, see <a href="https://docs.aws.amazon.com/kms/latest/developerguide/key-state.html">How Key State Affects Use
 * of a Customer Master Key</a> in the <i>AWS Key Management Service Developer Guide</i>.</p>
 */
var VerifyCommand = /** @class */ (function (_super) {
    __extends(VerifyCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function VerifyCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    VerifyCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "KMSClient";
        var commandName = "VerifyCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: VerifyRequest.filterSensitiveLog,
            outputFilterSensitiveLog: VerifyResponse.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    VerifyCommand.prototype.serialize = function (input, context) {
        return serializeAws_json1_1VerifyCommand(input, context);
    };
    VerifyCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_json1_1VerifyCommand(output, context);
    };
    return VerifyCommand;
}($Command));
export { VerifyCommand };
//# sourceMappingURL=VerifyCommand.js.map